<template>
  <div>
    <div class="parallax"></div>
    <div class="container" id="contactUs">
      <h2> Contáctenos </h2>
      <div class="contact">
        <input type="email" v-model="email" placeholder="Su email"><br>
        <input type="text" v-model="subject" placeholder="Sujeto"><br>
        <textarea class="textarea" type="textarea" rv-model="message"></textarea>
        <a v-if="visibleSendButton" :href="mailto" target="_blank">Enviar email</a>
        <p v-else class="error">{{error}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      message: '',
      subject: '',
      mailto: '',
      visibleSendButton: false,
      error: "Por favor complete todas las zonas de texto"
    }
  },
  methods: {
    checkFields() {
      if(this.email !== '' && this.message !== '' && this.subject !== '') {
        var re = /\S+@\S+\.\S+/;
        if(!re.test(this.email)) {
          this.error = "El formato del email no es correcto"
          this.visibleSendButton = false
        } else {
          this.error = ""
          this.visibleSendButton = true
          this.mailto = "mailto:vetopas@andorra.ad?subject=" + this.subject + "&body=" + this.message + "%0D%0AEnvoyé par : " + this.email
        }
      }
    }
  },
  watch: {
   email() {
     this.checkFields()
   },
   message() {
     this.checkFields()
   },
   subject() {
     this.checkFields()
   }
  }
}
</script>

<style scoped>
.parallax {
  background-image: url("../../../static/images/pexels-photo-126407.jpeg");
}

.contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
}

input {
  width: 80%;
  padding: 1em;
}

.textarea {
  height: 15em;
  width: 80%;
  padding: 1em;
  overflow-x: hidden;
  overflow-y: scroll;
}

.error {
  color: red;
}
.block {
  max-width: 30vw;
  margin: 2em;
}

</style>



// WEBPACK FOOTER //
// ContactUs.vue?94c635d4